import { MoveDocumentModal } from '@monorepo/shared/componentsV2/documents/MoveDocumentModal';
import {
  DocumentFileResponse,
  DocumentFolderWithFileCountResponse,
} from 'mapistry-shared';
import React, { useCallback } from 'react';
import { useUpdateOrganizationDocument } from '../../hooks/useUpdateOrganizationDocument';

interface MoveOrganizationDocumentModalProps {
  organizationId: string;
  document: DocumentFileResponse;
  folders: DocumentFolderWithFileCountResponse[];
  onClose: () => void;
}

export function MoveOrganizationDocumentModal({
  organizationId,
  document,
  folders,
  onClose,
}: MoveOrganizationDocumentModalProps) {
  const [move] = useUpdateOrganizationDocument({
    config: { throwOnError: true },
  });

  const onMove = useCallback(
    async (folderId: string | null) => {
      if (folderId == null) {
        throw new Error(
          'Organization documents cannot be moved to the top level',
        );
      }
      await move({
        organizationId,
        documentId: document.id,
        document: { folderId },
      });
    },
    [document.id, move, organizationId],
  );

  return (
    <MoveDocumentModal
      folders={folders}
      allowTopLevel={false}
      onMove={onMove}
      onClose={onClose}
      destinationLabel="Destination folder"
      destinationPlaceholder="Select a folder"
    />
  );
}
